/**
 * Pragmatic Semiconductor adapter — IOT-Z20-AMBIENT-SCAFFOLD-1 (ASPIRATIONAL).
 *
 * Pragmatic ships flexible NFC/RFID labels (FlexIC) printed on plastic film
 * at sub-cent unit cost. Each label embeds a tiny IC capable of carrying a
 * unique item identifier and minimal sensor state, readable by smartphones
 * and warehouse gateways.
 *
 * Operational status: ASPIRATIONAL — type-system awareness only. Activation
 * deferred until the ambient-IoT enablement session (2028+).
 *
 * Patent priority anchor: F-AMBIENT-IOT-PER-SKU-001.
 * Scaffold session: IOT-Z20-AMBIENT-SCAFFOLD-1.
 */

import { NotImplementedAdapter } from '../NotImplementedAdapter.js';

const PRAGMATIC_CAPABILITIES = {
  configKeys: {},
  telemetryTypes: ['temperature_c'],
  alertingMode: 'cloud',
  otaSupported: false,
  attestationSupported: false,
  rollbackSupported: false,
  pushLatencyExpectedMs: 0,
};

export class PragmaticAdapter extends NotImplementedAdapter {
  constructor(device) {
    super(device, 'pragmatic', PRAGMATIC_CAPABILITIES);
  }
}

export function createPragmaticAdapterFactory() {
  return (device) => new PragmaticAdapter(device);
}
